import Highcharts from 'highcharts';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './style';
import EmojiMap from '../../../Overview/components/OverviewComp/components/EmojiMap';
import { Typography } from '@hmsexp/component-library';
import { TouchableOpacity, View } from '../../../../components/Common/react-native-components';
import { getSentiment } from './utils';

export default function HighchartsReactTooltip({ chart, hoveredPoint }) {
  const [point, setPoint] = useState(null);

  useEffect(() => {
    if (!chart?.tooltip) return;
    function handleRefresh(e) {
      const p = Array.isArray(e) ? e[0] : e;
      setPoint(p);
    }
    Highcharts.addEvent(chart.tooltip, 'refresh', handleRefresh);
    return () => {
      if (chart?.tooltip?.refresh) {
        try {
          Highcharts.removeEvent(chart.tooltip, 'refresh', handleRefresh);
        } catch { }
      }
    };
  }, [chart]);
  if (!point) return null;

  const container = document.getElementById('recent-online-review-feedback-tooltip-container');
  if (!container) return null;

  function onViewDetailsClick(data) {

    if (data?.data?.feedback_id) {
      window.open(`/dashboard/feedback_details/${data?.data?.feedback_id}`, '_blank');
    }
  }

  return ReactDOM.createPortal(
    <div
      style={{
        ...styles.tooltipContainer,
        pointerEvents: 'auto'
      }}>
      <div style={styles.tooltipDataContainer}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <EmojiMap
            height='40'
            width='40'
            subIconType={hoveredPoint?.data?.source}
            type={getSentiment(hoveredPoint?.data?.normalized_score)}
          />
          <Typography variant='h5' textProps={{ style: { marginTop: 10 } }}>
            {hoveredPoint?.data?.normalized_score}
          </Typography>
          <Typography>
            {hoveredPoint?.data?.normalized_score}
            <Typography fontWeightType='regular'>/5</Typography>
          </Typography>
        </div>
        <div>
          <View style={styles.tooltipName}>
            <Typography variant='h6'>{hoveredPoint?.data?.guest_name}</Typography>
          </View>
          <View style={{ marginVertical: 5 }}>
            <Typography variant='body2' fontWeightType='medium'>
              Unit Name: {hoveredPoint?.data?.property_name}
            </Typography>
          </View>
          <Typography variant='body2' fontWeightType='medium'>
            Responsible Date: {hoveredPoint?.data?.response_date}
          </Typography>
        </div>
      </div>
      <View style={styles.tooltipDivider} />
      <View style={styles.tooltipFooter}>
        <TouchableOpacity onPress={() => onViewDetailsClick(hoveredPoint)}>
          <Typography fontWeightType='regular' color='hyperlinkContent'>
            View Details{' '}
          </Typography>
        </TouchableOpacity>
      </View>
    </div>,
    container
  );
}
